<template>
  <div class="delivery-tracker">
    <HeaderCheckout />
    <div class="delivery-title text-center">
      <h2>Delivery Tracker</h2>
    </div>
    <section class="section-b-space">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-sm-12 col-xs-12">
            <div class="row check-out">
                <MapDelivery />
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import HeaderCheckout from '@/components/header'
import Footer from '@/components/footer'
import MapDelivery from '@/components/map_delivery'

export default {
  components: {
    HeaderCheckout,
    Footer,
    MapDelivery,
  },
  computed: {
    ...mapGetters({
    }),
  },
  mounted() {

  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
